import { render, staticRenderFns } from "./EditMenuGroup.vue?vue&type=template&id=073451e6&scoped=true"
import script from "./EditMenuGroup.vue?vue&type=script&lang=js"
export * from "./EditMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./EditMenuGroup.vue?vue&type=style&index=0&id=073451e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073451e6",
  null
  
)

export default component.exports